import { DateTimePicker, Text, Label } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { InvoiceArrivalDetailsFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export const InvoiceDueDateFormInput = () => {
  const { t } = useTranslation("invoice_arrival");

  const { control } = useFormContext<InvoiceArrivalDetailsFormValues>();
  return (
    <View>
      <Label label={t("form.invoice_due_date.label")}></Label>
      <Text>{t("form.invoice_due_date.description")}</Text>
      <Controller
        name="invoiceDueDate"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <DateTimePicker
            value={value ? new Date(value) : undefined}
            onChange={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder=""
          />
        )}
      />
    </View>
  );
};
